export type ViewState =
  | 'form'
  | 'pending'
  | 'peer-response'
  | 'reminder'
  | 'access-unlocked'
  | 'attestation'
  | 'access-frozen';

export type RelationshipType =
  | ''
  | 'Spouse / Partner'
  | 'Child'
  | 'Parent'
  | 'Sibling'
  | 'Legal representative / Executor'
  | 'Other';

export interface PassingForm {
  dateOfPassing: string;
  relationship: RelationshipType;
  notes: string;
}

export interface AccountHolder {
  id: string;
  fullName: string;
  initials: string;
}

export interface Beneficiary {
  id: string;
  fullName: string;
  firstName: string;
  initials: string;
  email: string;
}

export interface NotificationDetail {
  submittedBy: Beneficiary;
  accountHolder: AccountHolder;
  dateOfPassing: string;
  relationship: string;
  submittedAt: string;
  deadlineAt: string;
  confirmedBy?: Beneficiary;
  disputedBy?: Beneficiary;
}

// ── Static mock data ─────────────────────────────────────────────

export const ACCOUNT_HOLDER: AccountHolder = {
  id:       'user_michael',
  fullName: 'Michael Anderson',
  initials: 'MA',
};

export const CURRENT_BENEFICIARY: Beneficiary = {
  id:        'benef_emily',
  fullName:  'Emily Anderson',
  firstName: 'Emily',
  initials:  'EA',
  email:     'emily.anderson@gmail.com',
};

export const SECONDARY_BENEFICIARY: Beneficiary = {
  id:        'benef_john',
  fullName:  'John Anderson',
  firstName: 'John',
  initials:  'JA',
  email:     'john.anderson@gmail.com',
};

export const NOTIFICATION_DETAIL: NotificationDetail = {
  submittedBy:    CURRENT_BENEFICIARY,
  accountHolder:  ACCOUNT_HOLDER,
  dateOfPassing:  '20 May 2026',
  relationship:   'Spouse / Partner',
  submittedAt:    'Today at 9:43 AM',
  deadlineAt:     '23 May 2026 at 9:43 AM',
  confirmedBy:    SECONDARY_BENEFICIARY,
  disputedBy:     SECONDARY_BENEFICIARY,
};

export const RELATIONSHIP_OPTIONS: RelationshipType[] = [
  'Spouse / Partner',
  'Child',
  'Parent',
  'Sibling',
  'Legal representative / Executor',
  'Other',
];

export const ACCESSIBLE_SECTIONS = [
  { icon: 'ti-checklist',  label: 'Checklist',         sub: 'Step-by-step guidance'         },
  { icon: 'ti-phone',      label: 'Critical contacts',  sub: 'Emergency & important numbers' },
  { icon: 'ti-heart',      label: 'Memories & stories',  sub: 'Photos, Videos and Voice records', sub2:'Access already given'},
];

// Countdown — 72 hours in seconds
export const COUNTDOWN_SECONDS = 72 * 60 * 60;
// Peer countdown shown on peer-response screen (68h remaining)
export const PEER_COUNTDOWN_LABEL = '68 hours remaining to respond';
